import {TOGGLE_PANEL, HIDE_PANEL, SHOW_PANEL} from '../../actionTypes';

export const toggle = () => ({
	type: TOGGLE_PANEL
});

export const hide_panel = () => ({
	type: HIDE_PANEL
});

export const show_panel = () => ({
	type: SHOW_PANEL
});